import React from "react";
import useProductName from "brand-customization/useProductName";
import useLicenseValidityForSubject from "license/hooks/useLicenseValidityForSubject";
import { ExternalLink } from "components/common";
import { UnlicensedText } from "components/loggers/ClusterSupportBundleInfo";
import { LICENSE_SUBJECTS } from "license/constants";
const EnterpriseSupportBundleInfo = () => {
  const productName = useProductName();
  const {
    data: { valid },
    isInitialLoading: isLoading
  } = useLicenseValidityForSubject(LICENSE_SUBJECTS.enterprise);
  if (isLoading) {
    return null;
  }
  if (!valid) {
    return /* @__PURE__ */ React.createElement(UnlicensedText, null);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("strong", null, "Please examine the bundle content before sending it to ", productName, ". It might contain sensitive data like IP addresses, hostnames or even passwords!"), /* @__PURE__ */ React.createElement("br", null), "After examination, you may attach it to your support case via \xA0", /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://support.graylog.org" }, "https://support.graylog.org"));
};
export default EnterpriseSupportBundleInfo;
